var Namespace = Namespace || (Namespace = {});

Namespace.Works = (function ($, window, document) {
	var filters = function () {
		window.shuffleInstance = new window.Shuffle(
			document.getElementById("grid"),
			{
				itemSelector: ".worksloop__col",
				sizer: ".my-sizer-element",
			}
		);

		$(document.body).on("click", "a[data-category]", function (e) {
			e.preventDefault();

			var $this = $(this);

			shuffleInstance.filter($this.attr("data-category"));

			$("a[data-category]").removeClass("active");
			$this.addClass("active");

			var $grid = jQuery("#grid");

			var offset =
				jQuery(".works__categorynav").outerHeight() +
				jQuery(".header").outerHeight();

			jQuery("html,body").animate(
				{
					scrollTop: $grid.offset().top - offset,
				},
				300
			);
		});
	};

	return {
		init: function () {
			loadJS(
				"https://cdnjs.cloudflare.com/ajax/libs/Shuffle/5.2.0/shuffle.min.js",
				function () {
					filters();
				}
			);
		},
	};
})(window.jQuery, window, document);

window.addEventListener("DOMContentLoaded", function () {
	var $container = jQuery(".worksloop__col");

	$container.on(
		"touchstart mouseenter focus",
		".hovercard--work",
		function (e) {
			var $this = jQuery(this);

			if ($this.hasClass("active")) {
				return;
			}

			$this.addClass("active");

			setTimeout(function () {
				$this.addClass("pe-all");
			}, 300);
		}
	);

	$container.on("mouseleave", ".hovercard--work", function (e) {
		if (!jQuery(e.target).hasClass("hovercard--work__inner")) {
			return;
		}

		var $this = jQuery(this);

		if (jQuery(window).outerWidth() <= 767) {
			return;
		}

		$this.removeClass("pe-all");

		setTimeout(function () {
			$this.removeClass("active");
		}, 75);
	});

	$container.on("click", ".hovercard--work__close", function (e) {
		var $card = jQuery(this).closest(".hovercard--work");

		$card.removeClass("pe-all");

		setTimeout(function () {
			$card.removeClass("active");
		}, 75);

		if (e.type == "touchstart") {
			// Don't trigger mouseenter even if they hold
			e.stopImmediatePropagation();
			// If $item is a link (<a>), don't go to said link on mobile, show menu instead
			e.preventDefault();
		}
	});
});
